import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { updateBookmarkedVideos } from 'src/lib/redux';

import { ottVideoUserDataFetcher } from '../../fetchers/ott-fetcher';

type Props = {
  data: any;
  isLoading: boolean;
  refetch: () => void;
  isFetched: boolean;
  error: any;
};

const useOttVideoUserData = ({
  childId,
  enabled,
}: {
  childId: string;
  enabled: boolean;
}): Props => {
  const dispatch = useDispatch();

  const { data, isLoading, refetch, isFetched, error } = useQuery(
    [
      'ott-video-user-data',
      {
        childId,
      },
    ],
    ottVideoUserDataFetcher,
    {
      enabled,
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
      onSuccess: (responseData) => {
        // Update bookmark status for current video
        if (childId) {
          const bookmarks: Record<string, boolean> = {};
          bookmarks[childId] = responseData?.data?.isBookmark || false;
          dispatch(updateBookmarkedVideos({ bookmarkedVideos: bookmarks }));
        }
      },
    },
  );

  return {
    data,
    isLoading,
    refetch,
    isFetched,
    error,
  };
};

export default useOttVideoUserData;
